namespace GeniuzPOS.ReportMasterData {
    export class Report_1308Columns {
        static columnsKey = 'ReportMasterData.Report_1308';
    }
}
